export default "__VITE_ASSET__9zC26isg__"